<app-toolbar *ngIf="showComponent"></app-toolbar>

<div class="scroll-container">
  <router-outlet></router-outlet>

  <app-footer *ngIf="showComponent"></app-footer>
</div>
